import { Fragment } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Container,
} from "@mui/material";

import * as text from "../context/explanationText";

export default function Explanation() {

    return (
        <>
            <Container maxWidth={'xl'}>
                <Paper sx={{ padding: 4 }}>
                    <Typography variant="h4" pb={2}>
                        Explanation of measure categories
                    </Typography>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell sx={{width: "20%"}}>
                                        <Typography variant="h6">Category</Typography>
                                    </TableCell>
                                    <TableCell sx={{width: "25%"}}>
                                        <Typography variant="h6">Subcategory</Typography>
                                    </TableCell>
                                    <TableCell sx={{width: "55%"}}>
                                        <Typography variant="h6">Type</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {text.text.map((category) => (
                                    <Fragment key={category.category}>
                                    <TableRow sx={{backgroundColor: category.color}}>
                                        <TableCell rowSpan={(category.subcategories.map((subcategory) => subcategory.types.length).reduce((a, b) => a + b, 0)) + category.subcategories.length + 1}>
                                            <Typography paragraph>{category.category}</Typography>
                                            <Typography fontStyle={'italic'}>({category.description})</Typography>
                                        </TableCell>
                                    </TableRow>
                                    {category.subcategories.map((subcategory) =>(
                                        <Fragment key={subcategory.subcategory}>
                                        <TableRow sx={{backgroundColor: category.color}}>
                                            <TableCell rowSpan={subcategory.types.length + 1}>
                                                <Typography paragraph>{subcategory.subcategory}</Typography>
                                                <Typography fontStyle={'italic'}>({subcategory.description})</Typography>
                                            </TableCell>
                                        </TableRow>
                                        {subcategory.types.map((type) => (
                                            <TableRow key={type.type} sx={{backgroundColor: category.color}}>
                                                <TableCell>
                                                    <Typography>{type.type}</Typography>
                                                    <Typography fontStyle={'italic'}>({type.description})</Typography>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        </Fragment>
                                    ))}
                                    </Fragment>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </Container>
        </>
    );
}
